import { render, staticRenderFns } from "./Howto.vue?vue&type=template&id=4c51e938&"
import script from "./Howto.vue?vue&type=script&lang=js&"
export * from "./Howto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports